export default __webpack_public_path__ + "static/media/qr_code_background.a216987a.jpg";